import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../Enums/Tranlate";
import ZoneService from "../../../../../services/ZoneService";
import ParkingSlotsService from "../../../../../services/ParkingSlotsService";
import PhoneInput from "react-phone-input-2";

const FilterModal = ({ modal, setModal, params, setParams }) => {
	const [formData, setFormData] = useState({
		client_name: "",
		client_phone: "",
		vehicle_number: "",
		zone: "",
		parking_slot: "",
		floor: "",
		status: "",
	});
	const [loading, setLoading] = useState(false);
	const [zonesOptions, setZonesOptions] = useState([]);
	const [parkingSlotOptions, setParkingSlotOptions] = useState([]);
	const [floorsOptions, setFloorsOptions] = useState([]);
	const lang = useSelector((state) => state.auth.lang);
	const zoneService = new ZoneService();
	const statusOptions = [
		{ label: Translate[lang].pending, value: "pending" },
		{ label: Translate[lang].reject, value: "reject" },
		{ label: Translate[lang].parking, value: "parking" },
		{ label: Translate[lang].prepare_car, value: "prepare_car" },
		{ label: Translate[lang].ready, value: "ready" },
		{ label: Translate[lang].leave, value: "leave" },
	];
	const typesOptions = [
		{ label: Translate[lang].normal, value: "normal" },
		{ label: Translate[lang].qr, value: "qr" },
	];
	const parkingSlotsService = new ParkingSlotsService();

	useEffect(() => {
		Promise.all([zoneService?.getList()]).then((res) => {
			let data = [];
			if (res[0]?.status === 200) {
				data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
						floor: Number(info?.floor),
					};
				});
				setZonesOptions(data);
			}
		});
		setFormData({ ...params });
	}, []);

	useEffect(() => {
		if (!!formData?.zone?.value) {
			Promise.all([parkingSlotsService?.getList()]).then((res) => {
				if (res[0]?.status === 200) {
					let data = res[0]?.data?.data?.data?.map((info) => {
						return {
							...info,
							label: lang === "en" ? info?.name_en : info?.name_ar,
							value: info?.id,
						};
					});
					setParkingSlotOptions(data);
				}
				const result = Array.from(
					{ length: formData?.zone?.floor },
					(_, i) => ({
						label: i + 1,
						value: i + 1,
					})
				);
				setFloorsOptions(result);
			});
		}
	}, [formData?.zone]);

	const submit = (e) => {
		e.preventDefault();
		setLoading(true);
		let info = {};
		if (!!formData?.client_name) info["client_name"] = formData?.client_name;
		if (!!formData?.client_phone) info["client_phone"] = formData?.client_phone;
		if (!!formData?.vehicle_number)
			info["vehicle_number"] = formData?.vehicle_number;
		if (!!formData?.zone) info["zone"] = formData?.zone;
		if (!!formData?.parking_slot) info["parking_slot"] = formData?.parking_slot;
		if (!!formData?.floor) info["floor"] = formData?.floor;
		if (!!formData?.status) info["status"] = formData?.status;
		if (!!formData?.type) info["type"] = formData?.type;
		setParams({ ...info });
		setModal();
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade filter-modal" : "ar fade filter-modal"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Header>
					<div className="d-flex justify-content-between">
						<p
							className="mb-0"
							style={{
								fontWeight: "600",
								color: "#333",
								fontSize: "20px",
							}}>
							{Translate[lang]?.filter}
						</p>
						<Button
							variant=""
							className="close"
							style={{
								right: lang === "en" ? "0" : "auto",
								left: lang === "ar" ? "0" : "auto",
							}}
							onClick={() => {
								setModal();
							}}>
							<span style={{ fontSize: "22px" }}>&times;</span>
						</Button>
					</div>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.type}</label>
							<Select
								value={formData?.type}
								name="type"
								placeholder={Translate[lang]?.select}
								options={typesOptions}
								onChange={(e) => setFormData({ ...formData, type: e })}
							/>
						</Col>
						{/* Client Name */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.client_name}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.client_name}
								bsSize="lg"
								name="client_name"
								value={formData.client_name}
								onChange={(e) =>
									setFormData({
										...formData,
										client_name: e.target.value,
									})
								}
							/>
						</Col>
						{/* Client Phone */}
						<Col md={12} className="mb-3">
							<label>{Translate[lang]?.client_phone}</label>
							<PhoneInput
								country={"kw"}
								className="w-100"
								enableSearch={true}
								value={formData?.client_phone}
								onChange={(e) => setFormData({ ...formData, client_phone: e })}
							/>
						</Col>
						{/* Vehicle Number */}
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.vehicle_number}
							</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.vehicle_number}
								bsSize="lg"
								name="vehicle_number"
								value={formData.vehicle_number}
								onChange={(e) =>
									setFormData({ ...formData, vehicle_number: e.target.value })
								}
							/>
						</Col>
						{/* Zone */}
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.zone}</label>
							<Select
								value={formData?.zone}
								name="zone"
								placeholder={Translate[lang]?.select}
								options={zonesOptions}
								onChange={(e) =>
									setFormData({
										...formData,
										zone: e,
										floor: "",
										parking_slot: "",
									})
								}
							/>
						</Col>
						{/* Parking Slot */}
						<Col md={12} className="mb-3">
							<label className="text-label">
								{Translate[lang]?.parking_slot}
							</label>
							<Select
								value={formData?.parking_slot}
								name="parking_slot"
								placeholder={Translate[lang]?.select}
								options={parkingSlotOptions}
								onChange={(e) => setFormData({ ...formData, parking_slot: e })}
							/>
						</Col>
						{/* Floor */}
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.floor}</label>
							<Select
								value={formData?.floor}
								name="floor"
								placeholder={Translate[lang]?.select}
								options={floorsOptions}
								onChange={(e) => setFormData({ ...formData, floor: e })}
							/>
						</Col>
						{/* Status*/}
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.status}</label>
							<Select
								value={formData?.status}
								name="status"
								placeholder={Translate[lang]?.select}
								options={statusOptions}
								onChange={(e) => setFormData({ ...formData, status: e })}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex justify-content-between w-100">
						<Button
							variant="danger"
							onClick={() => {
								setParams({});
								setModal();
							}}
							type="button"
							disabled={loading}>
							{Translate[lang]?.clear_filter}
						</Button>
						<Button variant="primary" type="submit" disabled={loading}>
							{Translate[lang]?.apply_filter}
						</Button>
					</div>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default FilterModal;
